import React from 'react'
import PropTypes from 'prop-types'
import FixtureCard from '../FixtureCard'
import EmptyState from '../EmptyState'

const FeaturedFixtures = ({ data }) => {
  const edges = data
  const nodes = edges.map(node => node)
  const featured = nodes.filter(item => item.node.status === 'upcoming')
  const featuredCount = featured.length

  if (featuredCount === 0) {
    return (
      <EmptyState
        key="featured"
        section="featured"
        title="Featured Markets"
        text="Currently no featured markets available"
      />
    )
  }
  return (
    <>
      {edges.slice(0, 10).map(({ node }) => {
        if (node.status === 'upcoming') {
          return (
            <FixtureCard
              key={`${node.id}-${node.sport}-${node.slug}`}
              fixture={node}
              subheader
              size="small"
            />
          )
        }
        return null
      })}
    </>
  )
}

FeaturedFixtures.propTypes = {
  data: PropTypes.array.isRequired,
}

export default FeaturedFixtures
